export const subClassificationSchema = {
	schema: {
		title: 'sub classification schema',
		description: 'Sub Classification Schema',
		version: 0,
		primaryKey: 'code',
		type: 'object',
		properties: {
			code: {
				type: 'string',
				maxLength: 250,
			},
			name: {
				type: 'string',
			},
			image: {
				type: 'string',
			},
		},
		required: ['code', 'name', 'image'],
	},
};
